import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@geely/ui";
import { Calendar, Search } from 'lucide-react';

export function LandingPage() {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12 max-w-6xl">
        {/* Options */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-5">
          {/* New Appointment */}
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4 mx-auto">
                <Calendar className="size-8 text-white" />
              </div>
              <CardTitle className="text-center text-2xl">Novo Agendamento</CardTitle>
              <CardDescription className="text-center">
                Marque um novo horário de atendimento
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/booking">
                <Button className="w-full" size="lg">
                  Agendar Agora
                </Button>
              </Link>
            </CardContent>
          </Card>

          {/* Lookup Appointment */}
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4 mx-auto">
                <Search className="size-8 text-white" />
              </div>
              <CardTitle className="text-center text-2xl">Consultar Agendamento</CardTitle>
              <CardDescription className="text-center">
                Visualize, remarque ou cancele seu agendamento
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/lookup">
                <Button className="w-full" size="lg" variant="outline">
                  Consultar
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>

        {/* Info Section */}
        <div className="mt-16 max-w-3xl mx-auto">
          <Card>
            <CardHeader>
              <CardTitle>Como funciona?</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Escolha uma loja e horário</h3>
                  <p className="text-gray-600 text-sm">
                    Selecione a loja mais próxima de você e o melhor horário disponível
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Preencha seus dados</h3>
                  <p className="text-gray-600 text-sm">
                    Informe seus dados pessoais e informações do seu veículo para o atendimento
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">
                  3
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Receba sua confirmação</h3>
                  <p className="text-gray-600 text-sm">
                    Você receberá um ID de agendamento para consultar, remarcar ou cancelar
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </div>
  );
}
